export { VNavigationDrawer } from './VNavigationDrawer'
